import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit to Sponsor Faculty ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ( _ctx.IsStudent == 'Yes' &&
          _ctx.facultyDetails?.email != null && _ctx.facultyDetails.email != ``
          && _ctx.facultyDetails.fullname != null && _ctx.facultyDetails.fullname != ``
          && _ctx.facultyDetails.address != null && _ctx.facultyDetails.address != ``
          && _ctx.facultyDetails.research_description != null && _ctx.facultyDetails.research_description != ``
          && _ctx.currentApplication != null
          && (_ctx.currentApplication.appStatus == `Editing` || (_ctx.currentApplication.appStatus == `Re-assigned` && _ctx.currentFaculty.data.isApproved != true)) 
        )
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        id: "kt_account_profile_details_submit",
        ref: "submitButton1",
        class: "btn btn-primary me-2",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveChanges1(true)))
      }, _hoisted_3, 512))
    : _createCommentVNode("", true)
}